import React, { useState } from "react";
import "./OtherIncome.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import CustomSwitch from "../../../../../Components/CustomSwitch/CustomSwitch";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const initialData = [
  {
    id: 1,
    title:
      "Have you earned any interest & dividend income for 2020? If yes please upload 1099-INT & DIV",
    status: false,
  },
  {
    id: 2,
    title:
      "Did you receive any business income or loss for the year 2020? If yes please upload 1099-MISC",
    status: false,
  },
  {
    id: 3,
    title:
      "Have you sold any Stocks in 2020 if yes please provide 1099-B document?",
    status: true,
  },
  {
    id: 4,
    title: "If you sold any ESPP please provide us form 3922?",
    status: false,
  },
  {
    id: 5,
    title:
      "Do you have any rental Income & incurred any expenses related to that rental property in India or USA?",
    status: false,
  },
  {
    id: 6,
    title: "Have you earned any interest income in US or abroad (India)",
    status: false,
  },
  {
    id: 7,
    title:
      "Have you with draw money from HSA? If yes please upload form 1099-SA.",
    status: false,
  },
  {
    id: 8,
    title:
      "Have you with drawn money from IRA 401k? If yes please enter the amount and form 1099-R",
    status: false,
  },
  {
    id: 9,
    title:
      "Have you received any refund from states in Tax Year 2020 for the last year (only if return was itemized)?",
    status: false,
  },
  {
    id: 10,
    title: "Have you received any unemployment compensation 1099G.?",
    status: false,
  },
  {
    id: 11,
    title:
      "Did you get any income or losses from royalties, partnership, s-corporation & trusts etc. if yes please upload schedule k-1 (form 1065 or form 1120s).",
    status: false,
  },
  {
    id: 12,
    title:
      "Have you received any third-party payment? If yes please provide form 1099-K",
    status: false,
  },
];

const OtherIncome = () => {
  const [data, setData] = useState(initialData);
  const handleTabStatus = (id, status) => {
    const updatedData = [...data];

    const index = updatedData.findIndex((item) => item.id === id);
    if (index !== -1) {
      updatedData[index] = {
        ...updatedData[index],
        status: status,
      };
      setData(updatedData);
    }
  };
  return (
    <div className="cltdetails__otherincome_page">
      <div className="cltdetails__otherincome_contentwrap">
        <div className="cltdetails__otherincome_contentbox">
          <div
            className="cltdetails__otherincome_cboxheader"
            style={{ background: "rgba(191, 131, 255, 1)" }}
          >
            Other Income Info
          </div>
          <div className="cltdetails__otherincome_cboxbody">
            <div className="cltdetails__otherincome_cboxrow">
              {data?.map((tab) => (
                <div className="cltdetails__otherincome_questiontab">
                  <div className="cltdetails__otherincome_qtabcontent">
                    <div className="cltdetails__otherincome_qtableft">
                      {tab.title}
                    </div>
                    <div className="cltdetails__otherincome_qtabright">
                      <span>{tab.status ? "YES" : "NO"}</span>{" "}
                      <CustomSwitch
                        onSwitch={(active) => {
                          handleTabStatus(tab.id, active);
                        }}
                        color="rgba(191, 131, 255, 1)"
                        defaultChecked={tab.status}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="cltdetails__otherincome_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__otherincome_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__otherincome_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__otherincome_savebtnwrap">
          <button className="cltdetails__otherincome_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__otherincome_contentwrap">
        <div className="cltdetails__otherincome_bottombtns">
          <button className="cltdetails__otherincome_bbtnfilled">Submit</button>
          <button className="cltdetails__otherincome_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtherIncome;
